import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";

import Ff_Input from "../../../lib/ui/ff_input";

class Fortnox_Logg extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.cols = {};

    this.state.ix = 0;
    this.state.plu = "";
    this.state.text = "";
    this.state.pris = "";
    this.state.dto = {};
    this.state.fxa = [];
    if(props.wnds) {
        //this.state.tra = Object.values(this.state.dto.nts);
    }

    this.state.pdf = 0;
    this.state.pdf_content = null;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.fx_list();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
  tb_style() {
      var css = {};
      css.height = (window.innerHeight * 0.9) - 150;
      css.overflow = "auto";
      return css;
  }

    wnd_close = () => {
		this.props.ctx.setState({ wnds: {} });
	};

  pdf_done (ret) {
    this.setState({loading: 0, pdf: 0, pdf_content: null });
  }
  
  fx_logg() {
        var self = this;

        var prm = {};
        prm.req = "sys.sid.sid";
        prm.avd = this.state.avd;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rco));

            var syo = ret.rco;
            if(syo == "") return;
            //alert( Object.keys(syo.if.fortnox) );
            self.setState({ syo: syo });
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    fx_list() {
      var self = this;

      var prm = {};
      prm.req = "pos.pos_eko_if.list";
      prm.datum = "";
      prm.typ = "";

      net.sio_req(prm)
      .then(function(ret){
          //alert(JSON.stringify(ret.ok));

          self.setState({ fxa: ret.rca });
      })
      .catch(function(e){
          var txt = JSON.stringify(e);
      });
  }

  render() {

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="m2_dlg mx_70 flex-col" style={ this.dlg_style() }>

        <div className="flex-row" style={{padding:"5px",height:"30px"}}>
                    <div className="flex-row txt_18">
                        <div>FORTNOX LOGG</div>
                    </div>
                    <div className="flex-row flex txt_18">
                    </div>
            </div>
            <div className="divider_orange"></div>

        <div className="mx_content flex">

        <div className="web-row">

        <table className="table table-bordered">
            <thead>
            <tr>
                <th>Datum</th>
                <th>Typ</th>
                <th>Text</th>
                <th>Resultat</th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.fxa.map((row, key) =>
                <tr key={key} className="" onDoubleClick={() => this.row_sel(row) }>
                <td className="">{ row.ekoif00.e0datum }</td>
                <td className="">{ row.ekoif00.e0typ  }</td>
                <td className="">{ row.ekoif00.e0text }</td>
                <td className="">{ JSON.stringify(row.result) }</td>
                </tr>
            )}
            </tbody>
        </table>
        </div>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <div className="flex"></div>
        </div>
      </div>

    </div>
	;
	return html;
  };
}

export default Fortnox_Logg;